import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/Index.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
	  children:[
		  {
		    path: '/',
		    name: 'hexiao',
		    component: () => import('./views/Langkaka/hexiao.vue')
		  },
		  {
		    path: '/shangpin_mendian',
		    name: 'shangpin_mendian',
		    component: () => import('./views/Langkaka/shangpin_mendian.vue')
		  },
		  {
		    path: '/mendian_xiangqing',
		    name: 'mendian_xiangqing',
		    component: () => import('./views/App/mendian_xiangqing.vue')
		  },
		  {
		    path: '/dingdan_mendian',
		    name: 'dingdan_mendian',
		    component: () => import('./views/Langkaka/dingdan_mendian.vue')
		  },
		  {
		    path: '/dingdan_zitimendian',
		    name: 'dingdan_zitimendian',
		    component: () => import('./views/Langkaka/dingdan_zitimendian.vue')
		  },
		  
		  {
		    path: '/hexiaomingxi',
		    name: 'hexiaomingxi',
		    component: () => import('./views/Langkaka/hexiaomingxi.vue')
		  },
		  {
		    path: '/hexiaomingxiall',
		    name: 'hexiaomingxiall',
		    component: () => import('./views/Langkaka/hexiaomingxiall.vue')
		  },
		  
		  {
		    path: '/hexiao',
		    name: 'hexiao',
		    component: () => import('./views/Langkaka/hexiao.vue')
		  },
		  
		  
		  
		  {
		    path: '/shanghu',
		    name: 'shanghu',
		    component: () => import('./views/App/shanghu.vue')
		  },
		  
		  {
		    path: '/index',
		    name: 'index',
		    component: () => import('./views/App/index.vue')
		  },
		  {
		    path: '/huiyuan',
		    name: 'huiyuan',
		    component: () => import('./views/App/huiyuan.vue')
		  },
		  {
		    path: '/shanghu',
		    name: 'shanghu',
		    component: () => import('./views/App/shanghu.vue')
		  },
		  
		  {
		    path: '/hexiaomingxi',
		    name: 'hexiaomingxi',
		    component: () => import('./views/Langkaka/hexiaomingxi.vue')
		  },
		  
		  
		  {
		    path: '/paisongdian',
		    name: 'paisongdian',
		    component: () => import('./views/App/paisongdian.vue')
		  },
		  {
		    path: '/quan',
		    name: 'quan',
		    component: () => import('./views/App/quan.vue')
		  },
		  {
		    path: '/tixian',
		    name: 'tixian',
		    component: () => import('./views/App/tixian.vue')
		  },
		  {
		    path: '/liuyan',
		    name: 'liuyan',
		    component: () => import('./views/App/liuyan.vue')
		  },
		  {
		    path: '/zhifu',
		    name: 'zhifu',
		    component: () => import('./views/App/zhifu.vue')
		  },
		  {
		    path: '/weixincaidan',
		    name: 'weixincaidan',
		    component: () => import('./views/App/weixincaidan.vue')
		  },
		  {
		    path: '/wenzihuifu',
		    name: 'wenzihuifu',
		    component: () => import('./views/App/wenzihuifu.vue')
		  },
		  {
		    path: '/tuwenhuifu',
		    name: 'tuwenhuifu',
		    component: () => import('./views/App/tuwenhuifu.vue')
		  },
		  {
		    path: '/xitonghuifu',
		    name: 'xitonghuifu',
		    component: () => import('./views/App/xitonghuifu.vue')
		  },
		  {
		    path: '/wenzhang',
		    name: 'wenzhang',
		    component: () => import('./views/App/wenzhang.vue')
		  },
		  {
		    path: '/wenzhangfenlei',
		    name: 'wenzhangfenlei',
		    component: () => import('./views/App/wenzhangfenlei.vue')
		  },{
		    path: '/tianjiawenzhang',
		    name: 'tianjiawenzhang',
		    component: () => import('./views/App/tianjiawenzhang.vue')
		  },
		  {
		    path: '/zhiapi',
		    name: 'zhiapi',
		    component: () => import('./views/App/zhiapi.vue')
		  },
		  {
		    path: '/duanxinjiekou',
		    name: 'duanxinjiekou',
		    component: () => import('./views/App/duanxinjiekou.vue')
		  },
		  {
		    path: '/qitapeizhi',
		    name: 'qitapeizhi',
		    component: () => import('./views/App/qitapeizhi.vue')
		  },
		  {
		    path: '/pige_shangpin',
		    name: 'pige_shangpin',
		    component: () => import('./views/Pige/pige_shangpin.vue')
		  },
		  {
		    path: '/pige_fenlei',
		    name: 'pige_fenlei',
		    component: () => import('./views/Pige/pige_fenlei.vue')
		  },
		  {
		    path: '/pige_dingdan',
		    name: 'pige_dingdan',
		    component: () => import('./views/Pige/pige_dingdan.vue')
		  },
		  {
		    path: '/shangpin',
		    name: 'shangpin',
		    component: () => import('./views/Limitao/shangpin.vue')
		  },
		  {
		    path: '/yue',
		    name: 'yue',
		    component: () => import('./views/App/yue.vue')
		  },
		  {
		    path: '/weixinmingxi',
		    name: 'weixinmingxi',
		    component: () => import('./views/App/weixinmingxi.vue')
		  },
		  
		  {
		    path: '/jifen',
		    name: 'jifen',
		    component: () => import('./views/App/jifen.vue')
		  },
		  {
		    path: '/zhifu',
		    name: 'zhifu',
		    component: () => import('./views/App/zhifu.vue')
		  },
		  {
		    path: '/denglurizhi',
		    name: 'denglurizhi',
		    component: () => import('./views/App/denglurizhi.vue')
		  },
		  {
		    path: '/kuaidi',
		    name: 'kuaidi',
		    component: () => import('./views/App/kuaidi.vue')
		  },
		  {
		    path: '/kuaidi2',
		    name: 'kuaidi2',
		    component: () => import('./views/App/kuaidi2.vue')
		  },
		  {
		    path: '/fenlei',
		    name: 'fenlei',
		    component: () => import('./views/Limitao/fenlei.vue')
		  },
		  {
		    path: '/canshupeizhi',
		    name: 'canshupeizhi',
		    component: () => import('./views/App/canshupeizhi.vue')
		  },
		  {
		    path: '/dingdan',
		    name: 'dingdan',
		    component: () => import('./views/Limitao/dingdan.vue')
		  },
		  {
		    path: '/caozuo',
		    name: 'caozuo',
		    component: () => import('./views/App/caozuo.vue')
		  },
		  {
		    path: '/yinxiao',
		    name: 'yinxiao',
		    component: () => import('./views/App/yinxiao.vue')
		  },
		  // 店铺
		  // {
		  //   path: '/dianpuzhuanxiu',
		  //   name: 'dianpuzhuanxiu',
		  //   component: () => import('./views/App/dianpuzhuanxiu.vue')
		  // },
		  
		  {
		    path: '/haibao',
		    name: 'haibao',
		    component: () => import('./views/App/haibao.vue')
		  },{
		    path: '/xinxi',
		    name: 'xinxi',
		    component: () => import('./views/App/xinxi.vue')
		  },
		  {
		    path: '/rudao',
		    name: 'rudao',
		    component: () => import('./views/Limitao/rudao.vue')
		  }
		  ,
		  {
		    path: '/guanliyuan',
		    name: 'guanliyuan',
		    component: () => import('./views/App/guanliyuan.vue')
		  },
		  {
		    path: '/xitongguanli',
		    name: 'xitongguanli',
		    component: () => import('./views/Limitao/xitongguanli.vue')
		  },
		  {
		    path: '/jianzhi',
		    name: 'jianzhi',
		    component: () => import('./views/Pige/jianzhi.vue')
		  },
		  // {
		  //   path: '/fenpeiquanxian',
		  //   name: 'fenpeiquanxian',
		  //   component: () => import('./views/Limitao/fenpeiquanxian.vue')
		  // },
		  {
		    path: '/qingchushuju',
		    name: 'qingchushuju',
		    component: () => import('./views/App/qingchushuju.vue')
		  },
		  // 团购=====================================================
		  {
		    path: '/tuangou_shangpin',
		    name: 'tuangou_shangpin',
		    component: () => import('./views/Tuangou/shangpin.vue')
		  },
		  {
		    path: '/tuangou_dingdan',
		    name: 'tuangou_dingdan',
		    component: () => import('./views/Tuangou/dingdan.vue')
		  },
		  {
		    path: '/tuangou_fenlei',
		    name: 'tuangou_fenlei',
		    component: () => import('./views/Tuangou/fenlei.vue')
		  },
		  // 蚂蚁吧================================================
		  {
		    path: '/mayiba_shangpin',
		    name: 'mayiba_shangpin',
		    component: () => import('./views/Mayiba/mayiba_shangpin.vue')
		  },
		  {
		    path: '/mayiba_dingdan',
		    name: 'mayiba_dingdan',
		    component: () => import('./views/Mayiba/mayiba_dingdan.vue')
		  },
		  {
		    path: '/mayiba_fenlei',
		    name: 'mayiba_fenlei',
		    component: () => import('./views/Mayiba/mayiba_fenlei.vue')
		  },
		  
		  
		  
	  ]
    },
	{
	  path: '/denglu',
	  name: 'denglu',
	  component: () => import('./views/App/denglu.vue')
	},

	{
	  path: '/zhuce',
	  name: 'zhuce',
	  component: () => import('./views/App/zhuce.vue')
	},
	{
	  path: '/zhaohuimima',
	  name: 'zhaohuimima',
	  component: () => import('./views/App/zhaohuimima.vue')
	},
	{
	  path: '/dianpuzhuanxiu',
	  name: 'dianpuzhuanxiu',
	  component: () => import('./views/App/dianpuzhuanxiu.vue')
	},
	{
	  path: '/shangping_tianjia',
	  name: 'shangping_tianjia',
	  component: () => import('./views/Limitao/shangping_tianjia.vue')
	},
  ]
})
